import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import ItemInjector from "@mnjsplatform/components/lib/common/ItemInjector";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import RequestHistory from "./RequestHistory";
import UploadDocument from "./UploadDocument";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";

export default (props) => {
/*
    console.log(`ItemInject: props.viewMethod=${JSON.stringify(props.viewMethod)} rowKey=${JSON.stringify(props.rowKey)}`);
    console.log(`props=${JSON.stringify(props)}`);
*/
    return <ItemInjector key={props.row.MethodName}
        dataItem={{
        controller: "PrivateDocuments",
        methodName: props.row.MethodName,
        withParamset : true,
        fieldName: props.row.ClaimPDTypeId
    }}><ConnectedPrivateDocument {...props} /></ItemInjector>
};

class PrivateDocument extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false,
            uploadVisible: false,
            updateStateFlag: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps) {
        if (this.props.row.MethodName !== this.props.row.MethodName) {
            this.initialize();
        }
    }

    initialize = async () => {
        try {
            this.setState({isDataReady: false});
            try {
                await this.props.dispatch(this.props.dataItem.reset());
                await this.props.dispatch(this.props.dataItem.initialize(this.props.row, {
                    withParams: false,
                    withStyle: false
                }));
            } catch (e) {
                console.error(e);
            }
        } finally {
            this.setState({isDataReady: true})
        }
    }
    renderActions = (row) => {
        const headerAllowAdd = this.props.headerAllowAdd;
        return <div className="row" key={`Actions_${row.ClaimPDTypeId}`}>
            {row.AllowAdd === 1 && <div className="col-md-4">
                <button className="btn btn-regular -goahead" type="button" title={headerAllowAdd}
                        key={`${row.ClaimPDTypeId}_AllowAdd`}
                        onClick={() => this.uploadDocument(row)}>
                    <i className="search zmdi zmdi-accounts-add"
                       style={{}}/>&nbsp;{headerAllowAdd}
                </button>
            </div>}
        </div>
    }
    render() {
        let control;
        if (this.props.dataItem.rowsCount() === 0) {
            control = <div className="text-muted mb-2">{i18next.t("Data_Not_Found_1")}</div>;
        } else {
            control = this.props.row.IsXGrid === 1
                ? <GridView dataItem={this.props.dataItem} useItemStyle={true}/>
                : <ComplexParam dataItem={this.props.dataItem} readOnly={true} showApplyButton={false}
                                showSearchBar={false}
                                renderParams={paramRender}/>
        }
        return (
            <PlaceholderWrapper placeholderId={this.props.row.ClaimPDTypeId} showSplitterLine={false}
                                key={this.props.row.ClaimPDTypeId}
                                canCollapse={true} collapsed={true}
                                title={<><i className='fa fa-file-code-o'/> {this.props.row.ClaimPDTypeName}</>}>
                    <div className="ml-2">
                    {
                        this.state.isDataReady
                            ? control
                            : i18next.t('LoadingLabel')
                    }
                    {
                        this.state.isDataReady
                            ? <RequestHistory rowKey={{ClaimPDTypeId: this.props.row.ClaimPDTypeId, ClaimPDTypeName: this.props.row.ClaimPDTypeName}}
                                              updateStateFlag={this.state.updateStateFlag}/>
                            : i18next.t('LoadingLabel')
                    }
                	</div>
                {this.renderActions(this.props.row)}
                {this.state.uploadVisible &&
                    <UploadDocument row={this.props.row}
                                    onClose={this.onCloseUploadDocument}/>
                }
            </PlaceholderWrapper>
        );
    }
    uploadDocument = (row) => {
        this.setState({uploadVisible: true});
    }
    onCloseUploadDocument = () => {
        this.setState({uploadVisible: false, updateStateFlag: Date.now()});
    }
}

PrivateDocument.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    row: PropTypes.object,
    headerAllowAdd: PropTypes.string
}

PrivateDocument.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: ownProps.getItemState(state)
    }
}

const ConnectedPrivateDocument = connect(mapStateToProps)(PrivateDocument);